import PropTypes from "prop-types";
import React from "react";

const NotificationSubMessage = ({ html }) => {
  if (!html) {
    return null;
  }

  return (
    <p
      className={"text-xs font-medium leading-130 text-left m-0"}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

NotificationSubMessage.propTypes = {
  html: PropTypes.string
};

export default NotificationSubMessage;
